import React from 'react';
import PropTypes from 'prop-types';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Morebtn from '../../../components_v2/desktop/Morebtn';
import s from './NewsletterCard.scss';

const NewsletterEmailPopup = props => {
  const {
    heading,
    // description,
    promptUrl,
    onCloseCallback = () => {},
    serviceId,
    onSubscribe,
    userPreference,
    isSubscribed,
    subscribeCallback,
    iswap = false, // Add iswap to destructured props with default,
  } = props;
  return (
    <ErrorBoundary>
      <PopupPortal usePopupPortal preventBodyScroll>
        <div
          className={`${s.overlayWrap} ${s.Newscard} ${s.newsletterPreview}`}
        >
          <div className={s.overlayContent}>
            <button className={s.closeBtn} onClick={onCloseCallback} />
            <iframe src={promptUrl} title="Newsletter signup form" />
            <div className={s.popUpSubcribeBtn}>
              <div className={s.headingBox}>
                <span className={s.newsletterName}>{heading}</span>
                {/* <span className={s.descriptionText}>{description}</span> */}
              </div>
              <Morebtn
                onClick={() => {
                  if (typeof onSubscribe === 'function') {
                    onSubscribe(
                      serviceId,
                      userPreference,
                      subscribeCallback,
                      isSubscribed,
                    );
                  }
                  if (typeof onCloseCallback === 'function') {
                    onCloseCallback();
                  }
                }}
                moreText={isSubscribed ? 'Unsubscribe' : 'Subscribe Now'}
                noArrow
                redbg
                // hum iswap and !iswap use karte h
                fullWidth={iswap}
              />
            </div>
          </div>
        </div>
      </PopupPortal>
    </ErrorBoundary>
  );
};

NewsletterEmailPopup.propTypes = {
  heading: PropTypes.string,
  description: PropTypes.string,
  promptUrl: PropTypes.string,
  onCloseCallback: PropTypes.func,
  serviceId: PropTypes.string,
  onSubscribe: PropTypes.func,
  userPreference: PropTypes.object,
  isSubscribed: PropTypes.bool,
  subscribeCallback: PropTypes.func,
  iswap: PropTypes.bool,
};

export default NewsletterEmailPopup;
